import { render, staticRenderFns } from "./GoodsWrite.vue?vue&type=template&id=942804e8&"
import script from "./GoodsWrite.vue?vue&type=script&lang=js&"
export * from "./GoodsWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports